import React from 'react';

import { DateTimePicker } from '../../src';

const DateTimePickerDefaultExample = () => (
	<DateTimePicker clearControlLabel="Clear default example" />
);

export default DateTimePickerDefaultExample;
